import EvmConverter from './evmConverter?worker'
import type { EvmConverterPrimitive } from './evmConverterHelper'

export type EvmConverterWorker = {
  converter: EvmConverterPrimitive
}
export const createEvmConverterWorker = () => new EvmConverter()
